import { render, staticRenderFns } from "./EffectiveFileTable.vue?vue&type=template&id=8ee58c8a&scoped=true"
import script from "./EffectiveFileTable.vue?vue&type=script&lang=js"
export * from "./EffectiveFileTable.vue?vue&type=script&lang=js"
import style0 from "./EffectiveFileTable.vue?vue&type=style&index=0&id=8ee58c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ee58c8a",
  null
  
)

export default component.exports